import React from 'react';
import PropTypes from 'prop-types';

import animateHeadline from './animated-headline/animated-headline'

class AnimatedHeadline extends React.Component {
  componentDidMount() {
    if (this.props.animated?.length > 0) {
      animateHeadline();
    }
  }

  render() {
    const { before, animated, after, style } = this.props;

    return (
      <span className='animated-headline'>
        <h1 className='text-anim text-anim--fade'>
          {before && <span>{before}&nbsp;</span>}
          <span className='text-anim__wrapper'>
            {animated.map((piece, index) => (
              <span 
                key={index} 
                className='text-anim__word'
                style={style}
              >
                {piece}
              </span>
            ))}
          </span>
          {after && <span>&nbsp;{after}</span>}
        </h1>
      </span>
    );
  }
}

AnimatedHeadline.propTypes = {
  before: PropTypes.any,
  animated: PropTypes.array,
  after: PropTypes.any,
  style: PropTypes.object,
};

export default AnimatedHeadline;
